<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 19 36"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1177.000000, -225.000000)"
        fill-rule="nonzero"
        stroke="currentColor"
        stroke-width="1.7"
      >
        <g transform="translate(1132.000000, 161.000000)">
          <g transform="translate(46.000000, 65.000000)">
            <path
              d="M13.6,18.7 L13.6,5.1 C13.6,2.278 11.322,0 8.5,0 C5.678,0 3.4,2.278 3.4,5.1 L3.4,18.7 C1.343,20.247 0,22.729 0,25.5 C0,30.192 3.808,34 8.5,34 C13.192,34 17,30.192 17,25.5 C17,22.729 15.657,20.247 13.6,18.7 Z M6.8,5.1 C6.8,4.165 7.565,3.4 8.5,3.4 C9.435,3.4 10.2,4.165 10.2,5.1 L8.5,5.1 L8.5,6.8 L10.2,6.8 L10.2,10.2 L8.5,10.2 L8.5,11.9 L10.2,11.9 L10.2,15.3 L6.8,15.3 L6.8,5.1 Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
